import React from 'react';

interface TimestampDisplayProps {
  seconds: number;
  className?: string;
}

function formatTimestamp(seconds: number): string {
  const totalMs = Math.round(seconds * 1000);
  const ms = totalMs % 1000;
  const totalSec = Math.floor(totalMs / 1000);
  const sec = totalSec % 60;
  const min = Math.floor(totalSec / 60);

  const mm = String(min).padStart(2, '0');
  const ss = String(sec).padStart(2, '0');
  const mmm = String(ms).padStart(3, '0');

  return `${mm}:${ss}.${mmm}`;
}

const TimestampDisplay: React.FC<TimestampDisplayProps> = ({ seconds, className }) => {
  return (
    <span className={className}>
      {formatTimestamp(seconds)}
    </span>
  );
};

export default TimestampDisplay;
